import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import { BOLD_FONT_WEIGHT, LG_FONT_SIZE, LG_PADDING, PRIMARY_COLOR, SM_FONT_SIZE } from '../../components/Common/StyleElement';

export const ExampleContent = styled.div`
    display: flex;
    font-size: ${SM_FONT_SIZE};
    height: 100%;
    justify-content: center;
    flex-direction: column;
    text-align: left;
    transition: 0.5s ease;
    &:hover {
        color: ${PRIMARY_COLOR};
    }
`

export const ExampleTitle = styled.div`
    font-size: ${LG_FONT_SIZE};
    font-weight: ${BOLD_FONT_WEIGHT};
`

export const ExampleText = styled.div`
    font-size: ${SM_FONT_SIZE}
`

export const ExampleWrapper = styled(Row)`
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 15px -4px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    transition: 0.5s ease;
    margin-bottom: ${LG_PADDING};
    margin-top: ${LG_PADDING};
    &:hover {
        transform: scale(1.02);
        box-shadow: 0 1px 15px -4px rgba(0, 0, 0, 0.5);
      }
`

export const ExampleImg = styled.img`
    height: 200px;
    width: 200px;
    padding: 20px;
`